// extracted by mini-css-extract-plugin
export default {"error_tips_wrap":"style_error_tips_wrap__Vn90B","error_tips_icon":"style_error_tips_icon__aTsKu"};